import combineReducersNamed from '../../../util/reducers/combineReducersNamed';
import entityViewReducer from '../entityViewReducer';
import withLoadingCount from '../../../util/withLoadingCount';
import { GET_PRODUCT_DETAIL } from '../../../actions/resources/shopActions';

export default combineReducersNamed({
  product: withLoadingCount(entityViewReducer, GET_PRODUCT_DETAIL),
});
